module.exports = __webpack_public_path__ + "images/historical/Totals.png";